/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import AddCustomerController from "./add-customer.controller";
import CustomerRoutes from './customer.routes';
import CustomerDirective from './customer.directive';
import CustomerTableConfig from './customer-table.config';
import CustomerDetailsController from './customer-details.controller';

export default angular.module('tektelic.customer', [])
    .config(CustomerRoutes)
    .controller('CustomerDetailsController', CustomerDetailsController)
    .controller('AddCustomerController', AddCustomerController)
    .directive('tkCustomer', CustomerDirective)
    .factory('customerTableConfig', CustomerTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/customer/index.js